export default function E15Fuel() {
    return (
        <div>
            <h2>Higher Ethanol-Gasoline Blend Damages Boat Engines</h2>
            <p>
                Federal research into the use of <strong>E15</strong> (a new ethanol-gasoline blend of up to 15 percent alcohol) shows that it severely damaged boat engines, raising more concern for motorcycles.
            </p>
            <p>
                The government-funded research, done by Mercury Marine through the National Research Energy Lab (the only federal laboratory dedicated to the research, development, commercialization, and deployment of renewable energy and energy efficiency technologies), showed that the two-stroke and four-stroke Mercury engines used for the test had problems while running E15!
            </p>
            <p>
                The engines were a 9.9 horsepower four-stroke, a 300 horsepower supercharged four-stroke, and a 200 horsepower two-stroke.
            </p>
            <p>
                The report notes that all the engines ran hotter than with E10, which contains up to 10 percent ethanol.
            </p>
            <p>
                In the E15 testing, the 200 horsepower engine was destroyed when a rod bearing failed, and the valves in the 300 horsepower engine broke or cracked, forcing researchers to stop the testing. Researchers said the valve damage was due to high metal temperatures.
            </p>
            <p>
                The small engine made it through the 300 hours of testing but ran poorly and misfired at the end of testing. It also showed signs of reduced hardness on piston surfaces.
            </p>
            <p>
                In October 2010, the EPA approved the use of E15 in model year 2007 and newer light duty vehicles (cars, light duty trucks, and medium duty passenger vehicles). Then in January 2011, the EPA added model year 2001-2006 light duty vehicles to the approved list.
            </p>
            <p>
                <strong>No motorcycles or all-terrain vehicles are currently on the list.</strong>
            </p>
            <p>
                Concerns about E15 being mistakenly used and damaging engines in motorcycles and the possibility that “blender pumps” that dispense multiple grades of gasoline through a single hose might introduce enough ethanol into gasoline to be used in motorcycles to damage the vehicle.
            </p>
            <p>
                <em>*Reprinted without the permission of Americanmotorcyclist.com</em>
            </p>
            <p>
                <strong>ethanol damage on carb main jet</strong>
            </p>
        </div>
    );
}
